module.exports = __webpack_public_path__ + "static/newart2-7e0cda5dc56260edee6be4fb0b980e8a.jpg";